module.exports = __webpack_public_path__ + "img/wf.029f9765.svg";